<k-cards class="p-badge-inside p-badge-gradient-gray" [size]="size" [isResponsive]="isResponsive" pBadge [value]="count"
    iconPos="bottom" [ngClass]="{'badge-hidden':count==0}">
    <div class="card-content h-full w-full items-center" (click)="click()">
        <div class="pic-container">
            <img *ngIf="data.pic" class="pic" [src]="data.pic" />
        </div>
        <div class="footer relative">
            <div class="flex-wrapper h-full flex">
                <div class="title mb-3">{{data.title}}</div>
                <div class="description" text-cut [maxDigit]="size == 'sm' ? 60:85">{{data.shortDescription}}</div>
                <div class="currency-wrapper flex mt-0 sm:mt-auto items-end">
                    <div class="gradient-label flex items-center">
                        <img [src]="kmonCurrencyIcon" alt="kmon currency" class="w-4 h-4">
                        <!-- format-number -->
                        <span>
                            {{kmonAmount}}
                        </span>
                    </div>
                    <info-icon class="info-icon" *ngIf="data.candyPrice"
                        [settings]="{type:'currency',label:data.candyPrice, currencyType:'CANDIES'}"></info-icon>

                    <ng-container *ngFor="let price of data.prices">

                        <ng-container *ngIf="price.currency.symbol != 'KMON'">
                            <!-- FOLLOWING ngIf WILL EXCLUDE ALL CURRENCY WITH NO PIC, IN THIS WAY AUTOMATICALLY
                            EXCLUDE NOT HANDLED CURRENCY ADDED IN TEST -->
                            <info-icon *ngIf="handledCurrencies.includes(price.currency.symbol)" class="info-icon"
                                [settings]="{type:'currency',label:price.price, currencyType:price.currency.symbol}"></info-icon>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="description description-mobile" [ngClass]="{'w-11/12':data.isNFTBound}" text-cut
                [maxDigit]="size == 'sm' ? 60:80">
                {{data.shortDescription}}</div>
            <img *ngIf="data.isNFTBound" class="absolute w-[23px] h-[36px] right-[5px] bottom-[3px]"
                src="./assets/img/Icon/nft-bound.png" />
        </div>
    </div>
</k-cards>